import { render, staticRenderFns } from "./Ordemvitrineproxy.vue?vue&type=template&id=73594851&"
import script from "./Ordemvitrineproxy.vue?vue&type=script&lang=js&"
export * from "./Ordemvitrineproxy.vue?vue&type=script&lang=js&"
import style0 from "./Ordemvitrineproxy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports